/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import {
  TilesGridLoadingCell,
  TilesGridCellCard,
} from '@bingads-webui-campaign-react/asset-library-components';

import { getSharedAssetContainerStyle } from './styles/shared-cell-style';

const getStyle = (components, { palette = {} } = {}) => ({
  gridCellContainer: {
    ...getSharedAssetContainerStyle(components, { palette }),
  },
});

// invisible placeholder
const style = { visibility: 'hidden' };

export const AssetsGridLoadingCell = ({
  containerClass,
  onLoading,
  classes,
}) => (
  <TilesGridLoadingCell
    onLoading={onLoading}
    containerClass={classnames('tiles-grid-cell-content', containerClass || classes.gridCellContainer)}
  >
    <TilesGridCellCard>
      <div />
    </TilesGridCellCard>
    <div className={classnames('cell-description', 'loading-cell-description')}>
      <div style={style}>-</div>
    </div>
  </TilesGridLoadingCell>
);

AssetsGridLoadingCell.propTypes = {
  onLoading: PropTypes.func,
  containerClass: PropTypes.string,
  // injected styles
  classes: PropTypes.shape({
    gridCellContainer: PropTypes.string,
  }).isRequired,
};

AssetsGridLoadingCell.defaultProps = {
  onLoading: null,
  containerClass: undefined,
};

export const AssetLibraryAssetsGridLoadingCell
  = withDefaultStyles(AssetsGridLoadingCell, getStyle);
